import { createAction } from 'typesafe-actions';
import { IPumpingStationMotorPole } from '../../../../@types/model/masterData/pumpingStation/motorPole';

export default class MasterDataPumpingStationMotorPoleActions {
    public static readonly set = createAction('MASTER_DATA_SET_PUMPING_STATION_MOTOR_POLE', resolve => (pumps : Array<IPumpingStationMotorPole>) => resolve(pumps));
    public static readonly setLoading = createAction('MASTER_DATA_SET_PUMPING_STATION_MOTOR_POLE_LOADING', resolve => (isLoading : boolean) => resolve(isLoading));
}